export const StatusLabels = {
    'new_and_waiting_for_nlp': 'New & Waiting for NLP',
    'waiting_for_user_decision': 'Waiting for User Decision',
    'rejected': 'Rejected',
    'reference_added_to_existing_hv': 'Reference Added to Existing HV',
    'new_hv_created': 'New HV Created',
    'resolved_entry_id': 'Resolved Entry ID'
};
export const RefSystemLabels = {
    'icd': 'ICD',
    'loinc': 'LOINC',
    'snomed': 'SNOMED',
    'oid': 'OID',
    'rxnorm': 'RxNorm',
    'cpt': 'CPT'
};
//# sourceMappingURL=status-labels.js.map